import React from "react";
import CircleMemberDataContainer from "@commr/admin/components/circleMembers/circleMemberDataContainer";
import { CircleMember } from "@commr/admin/models/user/circleMember/circleMember";

const AddCircleMemberPage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <CircleMemberDataContainer circleMember={new CircleMember()} />
);

export default AddCircleMemberPage;
